import { render, staticRenderFns } from "./shared-list-aii.vue?vue&type=template&id=7c637219&scoped=true"
import script from "./shared-list-aii.vue?vue&type=script&lang=js"
export * from "./shared-list-aii.vue?vue&type=script&lang=js"
import style0 from "./shared-list-aii.vue?vue&type=style&index=0&id=7c637219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c637219",
  null
  
)

export default component.exports